import { ensureVendorHyperComplyOrganization } from "../api/api-methods";

export const VENDOR_ORGANIZATION_ERROR =
  "This vendor could not be set up in HyperComply. Try again, or contact support if it keeps failing.";

/**
 * The vendor's HyperComply organization id. Imported vendors have none, and their contacts cannot be
 * added without one, so it is created here. Returns a result object instead of throwing.
 */
export async function resolveVendorHyperComplyOrganization({
  providerId,
  organizationId,
  ensureOrganization = ensureVendorHyperComplyOrganization,
}) {
  const existing = Number(organizationId);
  if (Number.isInteger(existing) && existing > 0) {
    return { success: true, organizationId: existing };
  }

  try {
    const ensured = Number((await ensureOrganization(providerId))?.hc_org_id);
    return Number.isInteger(ensured) && ensured > 0
      ? { success: true, organizationId: ensured }
      : { success: false, message: VENDOR_ORGANIZATION_ERROR };
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || VENDOR_ORGANIZATION_ERROR,
    };
  }
}
